import dynamic from 'next/dynamic';

export const DynamicSearchOverlay = dynamic(
    () => import('./SearchOverlay').then(md => md.SearchOverlay),
    { ssr: false },
);
